<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div>
          <p>Статистика доставлених препаратов за период (<strong>30</strong>) дней</p>
          <p>Актемра (Тоцилизумаб) 200мг для ин. 20мг/мл 10мл №1 (77721915)</p>
          <p>Актемра (Тоцилизумаб) 400мг для ин. 20мг/мл 20мл №1 (7771500)</p>
          <p>Актемра (Тоцилизумаб) 80мг для ин. 20мг/мл 4мл №1 (77721916)</p>
          <p>Актемра раствор для инъекций 162мг/0,9мл №4 (77721919)</p>
        </div>
        <hr>
        <pulse-loader :loading="loading" :color="loadingColor" class="text-center"/>
        <div v-if="!loading">
          <table class="table table-striped table-bordered table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Курьер</th>
              <th>Даты</th>
              <th>Количество</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(runner, index) in getSortedRunners()" :key="runner.id">
              <td>{{ index + 1 }}</td>
              <td>{{ runner.name }}</td>
              <td>
                <span v-for="(date, index) in runnersData[runner.id].dates" :key="index">
                  <strong>{{ date.date }}</strong> ({{ date.order }}) {{ (index + 1) < runnersData[runner.id].dates.length ? ', ' : '' }}
                </span>
              <td>{{ runnersData[runner.id].qty }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api';

export default {
  data() {
    return {
      loadingColor: this.$constants.LOADING_COLOR,
      loading: false,
      runners: null,
      runnersData: null,
    }
  },
  mounted() {
    this.getDrugsData();
  },
  methods: {
    getSortedRunners() {
      return _.orderBy(this.runners, 'name');
    },
    async getDrugsData() {
      this.loading = true;
      const {data} = await api.post('/reports/drugPeriod', {
        drugIds: [77721915, 7771500, 77721916, 77721919],
        range: 30
      })
      if (data.success) {
        this.runners = data.runners;
        this.runnersData = data.runnersData;
      } else {
        toastr['warning'](data.message, 'Ошибка!');
      }
      this.loading = false;
    }
  }
}

</script>
